import { Reducer, Action } from "redux";
import { IWebinarsState, KnownAction, RECEIVE_WEBINAR_DATA, SHOW_LOADER } from "./types";

export const reducer: Reducer<IWebinarsState> = (state: IWebinarsState | undefined, incomingAction: Action): IWebinarsState => {
    if (state === undefined) {
        return { webinarsData: [], isLoading: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_WEBINAR_DATA:
            return {
                ...state,
                webinarsData: action.webinarsData,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
